import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import { Dictionary } from "lodash";

export class AlertService extends RLBaseService {

    static $inject = ["$resource", "$q"];

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
        super($resource);
    }

    getAlertFrequencyList() {
        return this.toRLService<Models.IAlertFrequency>("/api/alert/getalertfrequencylist").query().$promise;
    }

    getAlertTimeframeList() {
        return this.toRLService<Models.IAlertTimeframe>("/api/alert/getalerttimeframelist").query().$promise;
    }

    createAlert(alert: Models.IAlert) {
        return this.toRLService<number>("/api/alert/createalert").post(alert).$promise;
    }

    deleteAlert(alertID: number) {
        var data = { alertID: alertID };
        return this.toRLService<boolean>("/api/alert/deletealert").delete(data).$promise;
    }

    updateAlert(alert: Models.IAlert) {
        return this.toRLService<boolean>("/api/alert/updatealert").post(alert).$promise;
    }

    getAlertList(charTypeID: number, templateID: number, charID: number, recID: number) {
        var data = { charTypeID: charTypeID, templateID: templateID, charID: charID, recID: recID };
        return this.toRLService<Models.IAlert>("/api/alert/getalertlist").query(data).$promise;
    }

    getConfigAlertList(charTypeID: number, templateID: number, charID: number, recID: number) {
        var data = { charTypeID: charTypeID, templateID: templateID, charID: charID, recID: recID };
        return this.toRLService<Models.IAlert>("/api/alert/getconfigalertlist").query(data).$promise;
    }

    getParentRecordEntityID(entityID: string) {
        var data = { entityID: entityID };
        return this.toRLService<Models.IDataResponse<string>>("/api/alert/getparentrecordentityid").get(data).$promise;
    }

    getAlertContainsValueTypeList() {
        return this.toRLService<Models.IAlertContainsType>("/api/alert/getalertcontainsvaluetypelist").query().$promise;
    }

    alertContainsValuesToLookup(options: Models.IAlertContainsType []) {
        return options.reduce<Dictionary<string>>((lookup, next) => {
            lookup[next.value] = next.label;
            return lookup;
        }, {});
    }
}